import React, { useState } from 'react'
import { Button } from '@material-ui/core'
import { useStyles } from './NewsletterSubscription.styles'
import { LightText } from 'components/ui/Typography/LightText'
import { NewsletterSubscriptionModal } from './NewsletterSubscriptionModal'

export enum ETypeNewsletter {
  SUBSCRIBE = 'subscribe'
}

interface INewsletterSubscriptionProps {
  t: (key: string) => string
}

export const NewsletterSubscription = ({ t }: INewsletterSubscriptionProps) => {
  const classes = useStyles()
  const [type, setType] = useState('')
  const [isOpen, setIsOpen] = useState(false)

  const handleModal = (type: string) => {
    setType(type)
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <section className={classes.root}>
      <LightText>{t('description')}</LightText>
      <div className={classes.action}>
        <Button
          className={classes.subscribeButtom}
          onClick={() => handleModal(ETypeNewsletter.SUBSCRIBE)}
          variant="outlined"
          disableElevation
        >
          {t(ETypeNewsletter.SUBSCRIBE)}
        </Button>
      </div>
      <NewsletterSubscriptionModal t={t} isOpen={isOpen} onClose={handleClose} type={type} />
    </section>
  )
}
